module.exports = __webpack_public_path__ + "mo.59c91c04.svg";